import * as React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

interface SimpleCardProps {
    dim?: boolean;
    endIcon?: React.ReactNode;
    icon?: React.ReactNode;
    label: string;
    subtitle?: string;
    onClick: () => void;
}

export default function SimpleCard({
    dim = false,
    endIcon,
    icon,
    label,
    subtitle,
    onClick,
}: SimpleCardProps): React.JSX.Element {
    return (
        <Box
            onClick={onClick}
            sx={{
                backgroundColor: "#243049",
                padding: icon || subtitle ? "10px" : "16px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                gap: "15px",
                cursor: "pointer",
                transition: "background 0.2s",
                opacity: dim ? 0.75 : 1.0,
                "&:active": {
                    backgroundColor: "#26334d",
                },
            }}
        >
            {icon && (
                <Box
                    sx={{
                        width: 30,
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "1.5rem",
                    }}
                >
                    {icon}
                </Box>
            )}
            {subtitle ? (
                <Stack spacing={0.25}>
                    <Typography
                        variant="body1"
                        sx={{
                            color: "white",
                            fontWeight: 700,
                            fontSize: "1.1rem",
                        }}
                    >
                        {label}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#94a3b8",
                            fontSize: "0.8rem",
                            fontWeight: 400,
                        }}
                    >
                        {subtitle}
                    </Typography>
                </Stack>
            ) : (
                <Typography
                    sx={{
                        color: "white",
                        fontWeight: 600,
                        fontSize: "0.9rem",
                    }}
                >
                    {label}
                </Typography>
            )}
            {endIcon && (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        fontSize: "1.5rem",
                        marginLeft: "auto",
                    }}
                >
                    {endIcon}
                </Box>
            )}
        </Box>
    );
}
